import React, { useState } from 'react';
import Axios from "axios";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from 'sweetalert2';
import logo from '../../assets/logo.png';

function ForgotPassword() {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const clientID = localStorage.getItem("clientID")


  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();

    setIsLoading(true)
    const fliterdata = { email: data.email };
    Axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/forgotpassword`, fliterdata)
      .then((result) => {
        setIsLoading(false)
        if (result.data.message === "Email sent successfully") {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Reset password link sent to your email, please check your email for further instructions.',
          showConfirmButton: false,
          timer: 5000
        })
        
        //toast.success('Data Saving', {autoClose:5000})

      }
      else if(result.data.message ==="EmailID is not Exist") {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Please provide a valid Email ID.',
          showConfirmButton: false,
          timer: 5000
        })
        // toast.error('Issue with data format', {autoClose:5000})
      }

      else{
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Something gone wrong',
          showConfirmButton: false,
          timer: 5000
        })

      }
      }).catch(
        function (error) {
          console.log("Error" + error)
          setIsLoading(false)
        })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }


  return (
    <>
        <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
          <Link to="/Login">
           <img
                  src={logo} style={{ height: '60px',  margin: 15 }} alt="Logo"
                />
                </Link>
 <div className="container h-custom">

  <div className="row d-flex justify-content-center align-items-center mt-4">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div>
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <label className="form-label text-center">Forgot Password</label>
          <div className="d-flex flex-direction-row justify-content-center align-items-center form-outline mb-4">
          </div>

          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Email address
            </label>
            <input
              type="email"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
              placeholder="Enter a valid email address"
              {...register('email', { 
                required: 'Email is required', 
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address'
                }
              })}
            />
            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
          </div>
          <div className="text-center  d-flex justify-content-between text-lg-start mt-4 pt-2">
           
           <button
             type="submit"
             className="btn btn-primary"
             disabled={isSubmitting}
             style={{ backgroundColor: '#2e3192',borderRadius:8 }}
           >
             Submit
           </button>
           </div>
        </form>
      </div>
    </div>
  </div>
</div>

          </>
        }
      </section>
    </>
  )
}

export default ForgotPassword;